@if (exhibitor?.links) {
<section class="exhibitorlinks">
  <div class="mdc-layout-grid no-offset-x">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-2" i18n="@@featureExhibitorDetails-pageTabExhibitor-links"> Links </h2>
        <hr />
        <planone-link-list
          [links]="exhibitor?.links"
          [flowsContent]="true"
          (linkClick)="trackClick($event.element, 'EXTERNAL_LINK', $event.link.text)"></planone-link-list>
      </div>
    </div>
  </div>
</section>
}
